import { Box } from "@mui/material";
import { Link } from "react-router-dom";

const VisitorMenu = () => {
  return (
    <Box sx={{ display: "flex", columnGap: 1 }}>
      <Box sx={{ display: { xs: "none", sm: "block" } }}>
        <Link to={"/sign-up"} className="default-btn style-2 move-right">
          <span>Sign up</span>
        </Link>
      </Box>
      <Box>
        <Link to={"/sign-in"} className="default-btn move-right">
          <span>Log in</span>
        </Link>
      </Box>
    </Box>
  );
};

export default VisitorMenu;
